<template>
  <section>
    <!-- <component :is="getIcon" :key="iconType"></component>
     -->
       <b-img
            fluid
            :src="getIcon"
            alt="Login V2"
          />
<!--    <pre>-->
<!--      {{ iconType }}-->
<!--    </pre>-->
   <!-- <div v-if="iconType === 'users'">
     <AllUsers />
   </div> -->
<!--    <div v-if="iconType === 'verified'">-->
<!--      <VerifiedUsersIcon />-->
<!--    </div>-->
<!--    <div v-if="iconType === 'unverified'">-->
<!--      <UnverifiedUsersIcon />-->
<!--    </div>-->
<!--    <div v-if="iconType === 'signups'">-->
<!--      <SignupsIcon />-->
<!--    </div>-->
  </section>
</template>

<script>
import AllUsers from '@/assets/svg/AllUsers.svg';
import SubscriptionIcon from '@/assets/svg/SignupsIcon.svg';
import VerifiedUsersIcon from '@/assets/svg/VerifiedUsersIcon.svg';
import UnverifiedUsersIcon from '@/assets/svg/UnverifiedUsersIcon.svg';
import PatientsIcon from '@/assets/images/patients.png';
import ConsultationsIcon from '@/assets/images/consultations.png';
import AppointmentsIcon from '@/assets/images/appointments.png';
import ActiveDoctorsIcon from '@/assets/images/active_doctors.png';
import PatientIcon from '@/assets/images/patient.png';
import ActivePatientsIcon from '@/assets/images/active_patients.png';
import ActiveLabRequestsIcon from '@/assets/images/active_lab_requests.png';
import ApprovedLabsIcon from '@/assets/images/approved_labs.png';
import CancelledLabsIcon from '@/assets/images/cancelled_lab_requests.png';
import DeliverResultsIcon from '@/assets/images/delivered_results.png';
import PendingLabRequestsIcon from '@/assets/images/pending_lab_requests.png';

import { BImg, } from "bootstrap-vue";




export default {
  name: "UserIcons",
  components: {
    SubscriptionIcon,
    AllUsers,
    VerifiedUsersIcon,
    UnverifiedUsersIcon,
    BImg,
  },
  props: {
    iconType: {
      type: String,
      required: true,
      default: null
    }
  },
  computed: {
    getIcon() {
      const iconTypes = {
        users: AllUsers,
        verified: VerifiedUsersIcon,
        unverified: UnverifiedUsersIcon,
        subscriptions: SubscriptionIcon,
        patients: PatientsIcon,
        consultations: ConsultationsIcon,
        appointments: AppointmentsIcon,
        active_doctors: ActiveDoctorsIcon,
        patient: PatientIcon,
        active_patients: ActivePatientsIcon,
        active_lab_requests: ActiveLabRequestsIcon,
        approved_labs: ApprovedLabsIcon,
        cancelled_labs: CancelledLabsIcon,
        delivered_results: DeliverResultsIcon,
        pending_lab_requests: PendingLabRequestsIcon,
      }
      return iconTypes[this.iconType];
    }
  }
}
</script>

<style scoped>

</style>
